export enum SubmitStatus {
	Loading = "loading",
	Working = "working",
	Success = "success",
	Error = "error",
}
